import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { AdvertServiceDataType } from '@edikk-edikk/country-frontend';
import modelDetailParameterCss from '#advertDetail/assets/model-detail/model-detail-parameter.module.scss';
import { ServicePrice } from '#advertDetail/components/service-list/ServicePrice';

type PropsType = {
  serviceData: AdvertServiceDataType;
};

const ServiceValue: FC<PropsType> = ({
  serviceData,
}) => {
  let content = <FormattedMessage defaultMessage="Not" />;
  if (serviceData.isActive) {
    content = <FormattedMessage defaultMessage="Yes" />;
  }

  return (
    <div className={modelDetailParameterCss.modelDetailParameter__value}>
      {content}
      <ServicePrice serviceData={serviceData} />
    </div>
  );
};

export { ServiceValue };
